import { css } from '@linaria/core'
import { type FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppNavigation } from '#app/navigation/NavigationContext'
import { IconButton } from '#components/IconButton'
import { AccessibilityDropdown } from '#features/AccessibilityDropdown'
import { AdditionalSettings } from '#features/AdditionalSettings'
import { HeaderTabsContainer as HeaderTabs, HeaderToolsContainer as HeaderTools } from '#features/AppLayout'
import { ConfiguratorExportFavoritesModal } from '#features/FavoriteSets/ConfiguratorExportFavoritesModal'
import { ConfiguratorImportFavoriteSetModal } from '#features/FavoriteSets/ConfiguratorImportFavoriteSetModal'
import { ConfigurationFeedbackDropdown } from '#features/Feedback/ConfigurationFeedbackDropdown'
import { HeaderTabsContainer } from '#features/HeaderTabsContainer'
import { HeaderToolsContainer } from '#features/HeaderToolsContainer'
import { UserDropdown } from '#features/User/UserDropdown'
import { useIsAuthenticated } from '#features/User/userManager'
import ArrowIcon from '#icons/arrow-right-24.svg'
import ImportIcon from '#icons/cloud-upload-outline-24.svg'
import ExportIcon from '#icons/download-24.svg'
import { testIds } from '#utils/testIds'
import { CallingSystemExit } from './CallingSystemExit'

const feedbackClass = css`
  display: flex;
  align-items: center;
`

export const AppUserDropdown: FC = () => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false)

  const [favImportModalOpen, setFavImportModalOpen] = useState(false)
  const [favExportModalOpen, setFavExportModalOpen] = useState(false)
  const { t } = useTranslation()
  const { navigate, routes } = useAppNavigation()

  return (
    <>
      {favExportModalOpen && <ConfiguratorExportFavoritesModal open={favExportModalOpen} onOpenChange={setFavExportModalOpen} />}
      {favImportModalOpen && <ConfiguratorImportFavoriteSetModal open={favImportModalOpen} setOpen={setFavImportModalOpen} />}

      <UserDropdown className={feedbackClass} isOpen={userDropdownOpen} setIsOpen={setUserDropdownOpen}>
        <IconButton
          iconUrl={ExportIcon}
          iconFirst
          className="_export"
          title={undefined}
          onClick={() => {
            setUserDropdownOpen(false)
            setFavExportModalOpen(true)
          }}
          data-testid={testIds.favorites.showExportModal}
        >
          {t('user.action.export-favorites', 'Export Favorites')}
        </IconButton>
        <IconButton
          iconUrl={ImportIcon}
          iconFirst
          className="_import"
          title={undefined}
          onClick={() => {
            setUserDropdownOpen(false)
            setFavImportModalOpen(true)
          }}
          data-testid={testIds.favorites.showImportModal}
        >
          {t('user.action.import-favorites', 'Import Favorites')}
        </IconButton>
        <hr />
        <IconButton
          iconUrl={ArrowIcon}
          iconFirst
          className="_import"
          title={undefined}
          onClick={() => navigate(routes.setup.make())}
          data-testid={testIds.userSettings.goToTechnicalSetup}
        >
          {t('setup.page.technical-setup', 'Technical Setup Page')}
        </IconButton>
      </UserDropdown>
    </>
  )
}

export const AppHeader: FC = () => {
  const isAuthenticated = useIsAuthenticated()
  return (
    <>
      {isAuthenticated && (
        <HeaderTabs>
          <HeaderTabsContainer />
        </HeaderTabs>
      )}
      <HeaderTools>
        <HeaderToolsContainer>
          <ConfigurationFeedbackDropdown className={feedbackClass} />
          <AccessibilityDropdown className={feedbackClass}>
            <AdditionalSettings />
          </AccessibilityDropdown>
          <AppUserDropdown />
          <CallingSystemExit />
        </HeaderToolsContainer>
      </HeaderTools>
    </>
  )
}
